<div class="container">
  <mat-tab-group>
    <mat-tab label="View All" [ngSwitch]="mode">
      <div class="table" *ngSwitchCase="'table'">
        <table style="width: 100%">
          <tr class="back">
            <th>Name</th>
            <th></th>
          </tr>
          <tr class="td" *ngFor="let datum of data">
            <td>{{ datum?.Name }}</td>
            <td>
              <button
                (click)="getValues(datum)"
                type="button"
                class="create"
                mat-raised-button
                color="primary"
              >
                View Values
              </button>
              <button
                (click)="delete(datum)"
                style="margin-left: 20px"
                type="button"
                class="create"
                mat-raised-button
                color="primary"
              >
                Delete
              </button>
            </td>
          </tr>
        </table>
      </div>
      <div *ngSwitchCase="'value'">
        <table style="width: 100%">
          <tr class="back">
            <th>Option Name</th>
            <th>Option Value</th>
            <th>
              <button
                (click)="back()"
                type="button"
                class="create"
                mat-raised-button
                color="primary"
              >
                Back
              </button>
            </th>
          </tr>
          <tr class="td" *ngFor="let datum of dropdown">
            <td>{{ datum?.OptionName }}</td>
            <td>{{ datum?.OptionValue }}</td>
            <td></td>
          </tr>
        </table>
      </div>
    </mat-tab>
    <mat-tab label="Add Dropdown">
      <div class="add">
        <form [formGroup]="Form" (ngSubmit)="onSubmit($event)" class="post">
          <div class="post">
            <div class="form">
              <span class="input">
                <mat-form-field>
                  <mat-label>Name</mat-label>
                  <input formControlName="Name" matInput />
                </mat-form-field>
              </span>
            </div>
            <div class="but">
              <button
                style="float: left"
                type="submit"
                class="create"
                mat-raised-button
                color="primary"
              >
                {{ isLoading ? "Saving..." : "Save" }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </mat-tab>
    <mat-tab label="Add Value">
      <div class="add">
        <form [formGroup]="Form2" (ngSubmit)="Submit($event)" class="post">
          <div class="post">
            <div class="form">
              <span class="input">
                <mat-form-field>
                  <mat-label>Select Dropdown</mat-label>
                  <mat-select
                    formControlName="DropdownId"
                    matNativeControl
                    required
                  >
                    <mat-option *ngFor="let datum of data" [value]="datum.Id">
                      {{ datum.Name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Option Name</mat-label>
                  <input formControlName="OptionName" matInput />
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Option Value</mat-label>
                  <input formControlName="OptionValue" matInput />
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Option Code</mat-label>
                  <input formControlName="OptionCode" matInput />
                </mat-form-field>
              </span>
            </div>
            <div class="but">
              <button
                style="float: left"
                type="submit"
                class="create"
                mat-raised-button
                color="primary"
              >
                {{ isLoading ? "Saving..." : "Save" }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
